import { render, staticRenderFns } from "./PackageFormats.vue?vue&type=template&id=3d34d76a&scoped=true&lang=html&"
import script from "./PackageFormats.vue?vue&type=script&lang=js&"
export * from "./PackageFormats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d34d76a",
  null
  
)

export default component.exports